import moment from 'moment-timezone';

import SUPPORTED_LOCALES from '@/constants/supported-locales';
import detectDeviceLocale from '@/helpers/detect-device-locale';
import store from '@/store';



/**
 * Register moment locale data for every supported locale, then apply the
 * resolved device locale.
 *
 * Locales are defined inline via `moment.defineLocale` (with data sourced
 * from `constants/supported-locales.js`) rather than via side-effect imports
 * (`import 'moment/locale/en-gb'`). Those imports register the locale on
 * whatever moment instance the file resolves at evaluation time, which under
 * Vite can be a different copy than the one moment-timezone wraps — the
 * result is a silent no-op where `moment.locale('en-GB')` reverts to 'en'
 * because the locale was never registered on the active instance.
 *
 * `defineLocale` runs against the same moment-timezone export we use
 * elsewhere, so there's no instance-mismatch risk.
 */
Object.entries(SUPPORTED_LOCALES).forEach(([tag, data]) => {
  if (data.moment) {
    moment.defineLocale(tag.toLowerCase(), data.moment);
  }
});

// defineLocale switches moment to the most recently defined locale as a side
// effect. Reset to 'en' so the next call drives the choice deterministically.
moment.locale('en');



function setupLocale() {
  const locale = detectDeviceLocale();

  moment.locale(locale);
  store.commit('locale/SET_DEVICE_LOCALE', locale);
}



export default setupLocale;
